import {
  Box,
  Button,
  Chip,
  Drawer,
  FormControlLabel,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
  IconButton,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { rem } from "assets/js/common";
import { refreshFavInfo } from "assets/js/favInfo";
import { useHistory } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import AlertConfirm from "components/ui/alert-confirm";
import AlertComplete from "components/ui/alert-complete";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";
import { Cookies } from "react-cookie";
import Loading from "components/ui/loading";

export default function FavoriteStore() {
  const history = useHistory();
  const dispatch = useDispatch();
  const cookies = new Cookies();
  let favInfo = cookies.get("favInfo");
  console.log("favInfo: ", favInfo);

  const [favoriteStoreList, setFavoriteStoreList] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertMode, setAlertMode] = useState("");
  const [alertData, setAlertData] = useState("");
  const [favStoreTp, setFavStoreTp] = useState(
    favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1
  );

  const [isOpen, setIsOpen] = useState(false);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState(
    favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1
  );
  const [drawerConfirmOpen, setDrawerConfirmOpen] = useState(false);
  const [fetching, setFetching] = useState(false);

  useEffect(() => {
    if (history.location.state && history.location.state.tp) {
      setFetching(true);
      loadList(history.location.state.tp);
      setDrawerData(history.location.state.tp);
    } else {
      setFetching(true);
      loadList(favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1);
    }

    if (!favInfo.favMt && !favInfo.favMk) {
      setDrawerConfirmOpen(true);
    }
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "매장 찾기", menu: true }));
  }, [init]);

  useEffect(() => {
    if (!favInfo.favMt && !favInfo.favMk) {
      setDrawerConfirmOpen(true);
    }
  }, [favStoreTp]);

  const loadList = async (tp) => {
    if (tp) setFavStoreTp(tp);
    await axios
      .get("/api/sm/store", { params: { schTp: tp } })
      .then((res) => {
        setFavoriteStoreList(res.data.data.storeList);
        setFetching(false);
      })
      .catch((error) => {
        setFetching(false);
      });
  };

  const registFavStore = (cd) => {
    axios.post("/api/sm/store/regist", { cd: cd }).then((res) => {
      loadList(drawerData);
      refreshFavInfo();
    });
  };

  const handleAlertMode = (mode, item) => {
    setAlertMode(mode);
    setOpen(true);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const callback = () => {
    handleAlertClose(false);
    loadDetail();
  };

  window.appBackKeyHandle = () => {
    if (drawerConfirmOpen) {
      setDrawerConfirmOpen(false);
    } else if (drawerOpen) {
      setDrawerOpen(false);
    } else if (open) {
      setOpen(false);
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    if (drawerOpen === true) setDrawerData(favStoreTp);
  }, [drawerOpen]);

  return (
    <>
      <Loading open={fetching} />
      <div className="favoriteStore">
        <div className="type-select">
          <Box display="flex" justifyContent="flex-start">
            <Button
              onClick={() => {
                setDrawerOpen(true);
              }}
              className="fontN"
            >
              {favStoreTp == 1 ? "메가마트" : "메가마켓"}
              <i class="ico-filter" />
              {/* <img
              src={`${process.env.PUBLIC_URL}/images/icon/dropdown-icon.svg`}
            /> */}
            </Button>
          </Box>
        </div>
        <ul className="store-list">
          {favoriteStoreList.map((item, i) => (
            <li
              key={i}
              className="store-item"
              onClick={() => {
                history.push({
                  pathname: `/favorite-store/detail/${item.cd}`,
                  props: {
                    cd: item.cd,
                  },
                });
              }}
            >
              <h3>
                {item.nm}
                {item.hoursOfOperInfo == "영업종료" ? (
                  <Chip
                    label="영업종료"
                    size="small"
                    className="disableChip"
                  />
                ) : item.hoursOfOperInfo == "영업중" ? (
                  <Chip label="영업중" color="primary" size="small" />
                ) : (
                  <Chip label="휴무일" size="small" className="blackChip" />
                )}
              </h3>
              <div className="location">{item.addr}</div>
              <table className="time-table">
                <colgroup>
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "80%" }} />
                </colgroup>
                <tbody>
                  <tr>
                    <th>영업시간</th>
                    <td>
                      {moment()
                        .hours(item.strtTm.substring(0, 2))
                        .minutes(item.strtTm.substring(2, 2))
                        .format("HH:mm")}
                      {" ~ "}
                      {item.tmTp == "1" ? "" : "익일 "}
                      {moment()
                        .hours(item.endTm.substring(0, 2))
                        .minutes(item.endTm.substring(2, 2))
                        .format("HH:mm")}
                    </td>
                  </tr>
                  <tr>
                    <th>휴무일</th>
                    <td>
                      {item.storeHolidayList.length > 0
                        ? item.storeHolidayList.map((holyItem, i) => (
                          <Fragment key={i}>
                            {moment(holyItem.hldyYmd).format("MM.DD(ddd)")}
                            {item.storeHolidayList.length == i + 1
                              ? ""
                              : ", "}
                          </Fragment>
                        ))
                        : "연중무휴"}
                    </td>
                  </tr>
                </tbody>
              </table>
              <Button
                onClick={(e) => {
                  e.stopPropagation();

                  item.regularStoreYn == "Y"
                    ? handleAlertMode("alreadyFavStore")
                    : handleAlertMode("registFavStore");

                  setAlertData(item);
                }}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/images/icon/star${item.regularStoreYn == "Y" ? "-on" : "-off"
                    }.svg`}
                />
              </Button>
            </li>
          ))}
        </ul>

        {/* ST : tp */}
        <Drawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => {
            setDrawerOpen(false);
          }}
          className="drawer-common-bottom size-small hg-auto"
        >
          <div className="drawer-head">
            <h3>매장 선택</h3>
            <IconButton
              aria-label="close"
              className="btn-close"
              onClick={() => {
                setDrawerOpen(false);
              }}
            >
              <span className="hidden">닫기</span>
            </IconButton>
          </div>

          <div className="drawer-body">
            <Box className="box-type-10">
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={drawerData}
                value={drawerData}
                name="radio-buttons-group"
                onChange={(e) => {
                  setDrawerData(e.target.value);
                }}
              >
                <FormControlLabel
                  value="1"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                      className="mgR15"
                    />
                  }
                  label="메가마트"
                />
                <FormControlLabel
                  value="2"
                  control={
                    <Radio
                      color="primary"
                      icon={<span className="radio-icon" />}
                      checkedIcon={<span className="radio-icon-checked" />}
                      className="mgR15"
                    />
                  }
                  label="메가마켓"
                />
              </RadioGroup>
            </Box>
          </div>
          <div className="drawer-foot">
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                console.log("drawerData: ", drawerData);
                loadList(drawerData);
                setDrawerOpen(false);
              }}
            >
              선택완료
            </Button>
          </div>
        </Drawer>
        {/* EN : tp */}

        {/* ST : Drawer-row */}
        <Drawer
          anchor="bottom"
          open={drawerConfirmOpen}
          onClose={() => {
            setDrawerConfirmOpen(false);
          }}
          className="drawer-common-bottom size-small hg-auto"
        >
          <div className="drawer-body">
            <Box
              className="box-type-1"
              display="flex"
              flexDirection="column"
              alignItems="center"
              textAlign="center"
              style={{ paddingBottom: rem(56) }}
            >
              <div
                className="illust"
                style={{ marginTop: rem(15), marginBottom: rem(25) }}
              >
                <img
                  src={`${process.env.PUBLIC_URL
                    }/images/icon/fav-store-illust.svg`}
                />
              </div>
              <strong className="drawer-txt">
                단골매장 설정하고
                <br />
                다양한 혜택을 만나보세요.
              </strong>
            </Box>
          </div>
          <div className="drawer-foot">
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setDrawerConfirmOpen(false);
              }}
            >
              확인
            </Button>
          </div>
        </Drawer>
        {/* EN : Drawer-row */}

        {alertMode == "registFavStore" ? (
          <AlertConfirm
            open={open}
            handleAlertClose={handleAlertClose}
            text={`${alertData.nm}을(를) 단골매장으로 설정하시겠습니까?`}
            action={() => {
              registFavStore(alertData.cd);
              handleAlertClose();
            }}
            callback={callback}
          />
        ) : (
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text="다른 매장을 단골매장으로 선택해주세요."
            action={handleAlertClose}
          />
        )}
      </div>
    </>
  );
}
